import { useContext } from "react";

import GlobalContext from "shared/providers/context/GlobalContext";

export default function isVideosDiscontinued() {
  const { state } = useContext(GlobalContext);
  const platformCreatedAt = new Date(state?.tenancy?.created_at);

  const limitDateToVideosSupported = new Date("2024-01-01");

  if (platformCreatedAt >= limitDateToVideosSupported) return false;
  else return true;
}
